<template>
  <div class="dialog" :class="bindClass" v-if="isOpen">
    <slot />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'modal',
  data() {
    return {};
  },
  methods: {
    ...mapActions([])
  },
  computed: {
    ...mapGetters([])
  },
  props: {
    bindClass: {
      default: [],
      type: [Object, Array]
    },
    isOpen: {
      default: false,
      type: Boolean
    }
  }
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Modal.vue